import { message } from "antd";
import { authHeader } from "../../../../helpers/auth-header";
import { client } from "../../../../actions";
import uri from "../../constants/uri";
import actions from "../actions/actions";

const getDebtorStates = () => async (dispatch) => {
	try {
		const response = await client.get(`${uri}/notification_receivable_states`, {
			headers: authHeader(),
    });
    dispatch({
      type: actions.DEBTOR_STATES_LOADED,
      payload: response.data,
    })
	} catch (error) {
		console.error(error);
	}
};

export default getDebtorStates;
